import { siteInfo } from '@/mocks/appData';

export default function DownloadSection() {
  return (
    <section id="download" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            立即下载 CPP 官方正版
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            选择您的设备平台，获取最新版本 {siteInfo.version}，安全无毒、极速下载
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          <div className="group relative p-8 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-100">
                <i className="ri-android-line text-2xl text-primary-600"></i>
              </div>
              <div>
                <h3 className="font-heading font-semibold text-foreground-900">Android 版本</h3>
                <p className="text-xs text-foreground-500">{siteInfo.version}</p>
              </div>
            </div>
            <div className="space-y-2 mb-6">
              <div className="flex items-center justify-between text-xs text-foreground-600">
                <span>安装包大小</span>
                <span className="font-medium">{siteInfo.androidSize}</span>
              </div>
              <div className="flex items-center justify-between text-xs text-foreground-600">
                <span>系统要求</span>
                <span className="font-medium">{siteInfo.androidRequirement}</span>
              </div>
              <div className="flex items-center justify-between text-xs text-foreground-600">
                <span>发布日期</span>
                <span className="font-medium">{siteInfo.versionDate}</span>
              </div>
            </div>
            <a
              href="#"
              className="block w-full text-center py-3 text-sm font-semibold whitespace-nowrap rounded-xl bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200"
            >
              <i className="ri-download-line mr-1.5"></i>
              Android 下载
            </a>
            <div className="mt-3 text-center">
              <span className="text-xs text-foreground-400">
                <i className="ri-shield-check-line mr-1"></i>
                官方数字签名验证
              </span>
            </div>
          </div>

          <div className="group relative p-8 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-accent-100">
                <i className="ri-apple-line text-2xl text-accent-600"></i>
              </div>
              <div>
                <h3 className="font-heading font-semibold text-foreground-900">iOS 版本</h3>
                <p className="text-xs text-foreground-500">{siteInfo.version}</p>
              </div>
            </div>
            <div className="space-y-2 mb-6">
              <div className="flex items-center justify-between text-xs text-foreground-600">
                <span>安装包大小</span>
                <span className="font-medium">{siteInfo.iosSize}</span>
              </div>
              <div className="flex items-center justify-between text-xs text-foreground-600">
                <span>系统要求</span>
                <span className="font-medium">{siteInfo.iosRequirement}</span>
              </div>
              <div className="flex items-center justify-between text-xs text-foreground-600">
                <span>发布日期</span>
                <span className="font-medium">{siteInfo.versionDate}</span>
              </div>
            </div>
            <a
              href="#"
              className="block w-full text-center py-3 text-sm font-semibold whitespace-nowrap rounded-xl bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors duration-200"
            >
              <i className="ri-download-line mr-1.5"></i>
              iOS 下载
            </a>
            <div className="mt-3 text-center">
              <span className="text-xs text-foreground-400">
                <i className="ri-app-store-line mr-1"></i>
                跳转至 App Store 官方页面
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}